import React from "react";

import moment from "moment";

import FirstChart from "./FirstChart";
import RatingMap from "./RatingMap";

import ModulePanel from "../../ModulePanel";

import surveyQuestions from "../../../screens/Survey/Questions/questions.json";

const Individual = ({ data, handleState})=>{
    const 
        { findings = 0, isMobile = false} = data,
        findingsLabel = (findings > 5 ? (findings > 8 ? "Promotor" : "Pasivo") : "Detractor"),
        findingsClass = (findings > 5 ? (findings > 8 ? "success" : "warning") : "danger");
    
    return (
        <div className="row">
            <div className="col-md-12 d-flex align-items-center">
                <button onClick={() => { handleState({ "individual": false })}} className="btn btn-large btn-primary mr-3">
                    <i className="fas fa-long-arrow-alt-left" /> Volver 
                </button>
                <h4>Feedback de {data.name} <br/><small><i>{data.email}</i></small></h4>
            </div>
            <div className="col-md-6">
                <FirstChart satisfaction_ratio={data.avg} avg_time={(data.endDate ? (data.endDate - data.startDate) : 0)} />

                <ModulePanel title={[""]}>
                    <div className="table-responsive">
                        <table className="table mg-b-0">
                            <tbody>
                                <tr>
                                    <td>Fecha:</td>
                                    <td>{moment.unix(data.startDate).format("YYYY-MM-DD HH:mm:ss")}</td>
                                </tr>
                                <tr>
                                    <td>Dispotivo:</td>
                                    <td>
                                        {isMobile && (
                                            <i className="fas fa-mobile-alt fa-2x" />
                                        )}

                                        {!isMobile && (
                                            <i className="fas fa-laptop fa-2x" />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"text-center alert alert-solid-" + findingsClass}>
                                        {findingsLabel}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ModulePanel>
            </div>

            <div className="col-md-6">
                <RatingMap satisfaction_questions={data} isIndividual={true} />

                <ModulePanel title={["Tiempos de diligenciamiento"]}>
                    {(data.endSatisfaction) && (
                        <React.Fragment>
                            <h6><small>Tiempo en encuesta de Satisfacción: <strong>{data.endSatisfaction - data.startDate} segundos</strong></small></h6>
                            {(data.endDate) && (
                                <h6><small>Tiempo en Preguntas: <strong>{data.endDate - data.endSatisfaction} segundos</strong></small></h6>
                            )}
                        </React.Fragment>
                    )}

                    {(data.endDate) && (
                        <h6><small>Tiempo total de diligenciamiento: <strong>{data.endDate - data.startDate} segundos</strong></small></h6>
                    )}
                </ModulePanel>
            </div>

            <div className="col-md-12">
                <ModulePanel title={[""]}>
                    <div className="table-responsive">
                        <table className="table mg-b-0">
                            <tbody>
                                {surveyQuestions.map((question)=>{
                                    if (data[question.value]){
                                        return(
                                            <tr key={question.value}>
                                                <td>{question.text}</td>
                                                <td>
                                                    {Array.isArray(data[question.value]) && (
                                                        data[question.value].join(", ")
                                                    )}

                                                    {(!Array.isArray(data[question.value])) && (
                                                        data[question.value]
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    }
                                    return null;
                                })}
                            </tbody>
                        </table>
                    </div>
                </ModulePanel>
            </div>
            
            {data.testimony && (
                <div className="col-md-12">
                    <ModulePanel title={["Testimonio"]}>
                        <p className="fa-2x">{data.testimony}</p>
                    </ModulePanel>
                </div>
            )}

        </div>
    )   
}
export default Individual;